module.exports = __webpack_public_path__ + "back.d209e95df32ae7973fa08a4a785ccb6f.svg";